var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';
import { Link, useLoaderData, useParams, useRevalidator } from 'react-router-dom';
import { createColumnHelper } from '@tanstack/react-table';

import { useSetAtom } from 'jotai';
import { Translate } from "../../../../I18N";
import * as pagesAPI from "../../../api/pages";
import { Button, ConfirmationModal, Table } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";

import { notificationAtom } from "../../../atoms";
import { FetchResponseError } from "../../../../../shared/JSONRequest";
import {
  EntityViewHeader,
  YesNoPill,
  TitleHeader,
  UrlHeader,
  ActionCell,
  UrlCell,
  ActionHeader,
  List } from "./components/PageListTable";


const pagesListLoader =
(headers) =>
async ({ params }) =>
pagesAPI.get(params.lang || 'en', headers);

const deletionNotification = (hasErrors) => ({
  type: !hasErrors ? 'success' : 'error',
  text: !hasErrors ? /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Deleted successfully.") : /*#__PURE__*/

  _jsx(Translate, {}, void 0, "An error occurred")

});
// eslint-disable-next-line max-statements
const PagesList = () => {
  const [selectedPages, setSelectedPages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const pages = useLoaderData();
  const revalidator = useRevalidator();
  const params = useParams();
  const setNotifications = useSetAtom(notificationAtom);

  const columnHelper = createColumnHelper();

  const deleteSelected = async () => {
    setShowModal(false);
    const sharedIds = selectedPages.map((row) => row.original.sharedId);
    const result = await Promise.all(
      sharedIds.map(async (sharedId) => pagesAPI.deleteBySharedId(sharedId))
    );
    const hasErrors = result.find((res) => res instanceof FetchResponseError) !== undefined;
    setNotifications(deletionNotification(hasErrors));
    revalidator.revalidate();
  };

  const columns = [
  columnHelper.accessor('title', {
    header: TitleHeader,
    meta: { headerClassName: 'w-2/6' }
  }),
  columnHelper.accessor('sharedId', {
    header: UrlHeader,
    cell: UrlCell,
    meta: { headerClassName: 'w-2/6' }
  }),
  columnHelper.accessor('entityView', {
    header: EntityViewHeader,
    cell: YesNoPill,
    meta: { headerClassName: 'w-1/6' }
  }),
  columnHelper.accessor('sharedId', {
    id: 'action',
    header: ActionHeader,
    cell: ActionCell,
    enableSorting: false,
    meta: { headerClassName: 'sr-only invisible bg-gray-50' }
  })];


  const confirmDeletion = () => {
    setShowModal(true);
  };

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-pages" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Pages" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: pages,
      enableSelection: true,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Pages"),
      onSelection: setSelectedPages,
      initialState: { sorting: [{ id: 'title', desc: false }] } }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: selectedPages.length ? 'bg-primary-50' : '' }, void 0,
    selectedPages.length > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: confirmDeletion,
      color: "error",
      "data-testid": "delete-page-btn" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedPages.length, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "of"),
    pages.length
    ),

    selectedPages.length === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Link, { to: `/${params.lang || 'en'}/settings/pages/page` }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "solid", color: "primary", type: "button" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add page")
    )
    )
    )
    )

    )
    ),
    showModal && /*#__PURE__*/
    _jsx("div", { className: "container w-10 h-10" }, void 0, /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Are you sure?"),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Do you want to delete the following items?"),
      body: /*#__PURE__*/_jsx(List, { items: selectedPages }),
      onAcceptClick: deleteSelected,
      onCancelClick: () => setShowModal(false),
      size: "lg" }
    )
    )

    ));

};
export { PagesList, pagesListLoader };